import { Injectable, inject } from '@angular/core';
import { AuthStoreDispatcher } from '@common/dispatchers/authentication.dispatcher';
import { AuthStoreSelector } from '@common/selectors/authentication.selector';

/**
 * Coordinates Dood JWT preservation while a real Firebase account is created/signed-in
 * during PATCH …/upgrade-anonymous (Authorization must stay the Dood guest JWT).
 */
@Injectable({
  providedIn: 'root',
})
export class AnonymousUpgradeSessionService {
  private readonly authSelector = inject(AuthStoreSelector);
  private readonly authDispatcher = inject(AuthStoreDispatcher);

  private preserve = false;
  private preserved: { token: string | null; tokenExpiresAt: number | null } | null = null;

  get isPreserving(): boolean {
    return this.preserve;
  }

  begin(): void {
    const status = this.authSelector.selectStatus();
    this.preserve = true;
    this.preserved = {
      token: status.token,
      tokenExpiresAt: status.tokenExpiresAt ?? null,
    };
  }

  /** Re-apply the Dood JWT if Firebase auth listeners overwrote the store. */
  restore(): void {
    if (!this.preserved) {
      return;
    }
    this.authDispatcher.updateStatus({
      token: this.preserved.token,
      tokenExpiresAt: this.preserved.tokenExpiresAt,
    });
  }

  /** After successful upgrade: drop the Dood JWT and keep the Firebase ID token. */
  finish(firebaseIdToken: string): void {
    this.preserve = false;
    this.preserved = null;
    this.authDispatcher.updateStatus({
      token: firebaseIdToken,
      tokenExpiresAt: null,
    });
  }

  /** After failed upgrade: restore the guest JWT and stop preserving. */
  cancel(): void {
    this.restore();
    this.preserve = false;
    this.preserved = null;
  }
}
